export default __webpack_public_path__ + "static/media/005.808e5070.png";